module.exports = __webpack_public_path__ + "img/icon_01_feature3.ac4a029d.svg";